export const baseData = {
  user_management:{
    name:'用户管理',
    icon:'icon-duorenyonghu2'
  },
  role_management:{
    name:'角色管理',
    icon:'icon-jiaoseguanli'
  },
  permession_management:{
    name:'菜单管理',
    icon:'icon-caidan'
  },
  detect_subject_management:{
    name:'检测项目管理',
    icon:'icon-jiance'
  },
  employee_management:{
    name:'员工管理',
    icon:'icon-duorenyonghu2'
  },
};



// WEBPACK FOOTER //
// ./src/service/baseData.js